package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.model.DateScheduleOverride
import br.com.heyagenda.domain.repository.AvailabilityRepository

class SaveDateOverrideUseCase(
    private val repository: AvailabilityRepository
) {
    suspend operator fun invoke(override: DateScheduleOverride): Result<Unit> {
        if (override.dateIso.isBlank()) {
            return Result.failure(IllegalArgumentException("A data da exceção é obrigatória."))
        }
        return repository.saveDateOverride(override)
    }
}
